var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5803 12.2736V7.27735V1.85302C21.5803 0.831259 20.7583 0 19.7479 0H1.8324C0.82201 0 0 0.831259 0 1.85302V13.1416C0 14.1634 0.82201 14.9946 1.8324 14.9946H10.44V17.2917H6.09696C5.90357 17.2917 5.74677 17.4503 5.74677 17.6459C5.74677 17.8415 5.90353 18 6.09696 18H15.4833C15.6767 18 15.8335 17.8415 15.8335 17.6459C15.8335 17.4503 15.6768 17.2917 15.4833 17.2917H11.1403V14.9946H17.0167C17.0167 14.9946 17.2903 14.9946 17.8555 14.9946H19.8885C21.6332 14.9946 21.5803 13.5534 21.5803 12.9819V12.2736ZM17.0167 14.2864H1.8324C1.20819 14.2864 0.700379 13.7729 0.700379 13.1417V12.9819H17.0167V14.2864ZM17.0167 12.2736L0.70033 12.2736V1.85302C0.70033 1.22174 1.20815 0.708209 1.83235 0.708209H19.7479C20.3721 0.708209 20.8799 1.22174 20.8799 1.85302V7.27735V12.2736C20.3148 12.2736 17.0167 12.2736 17.0167 12.2736ZM20.8799 12.9819C20.8799 13.1629 20.9814 14.2864 20.2375 14.2864H18.0417H17.717V12.9819H20.8799Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.93068ddd2edfa85506f0b1fdeb30cbcc.svg";
export { ForwardRef as ReactComponent };